import type {
  CompanyShippingAddress,
  ShippingAddressSetResult,
} from '@maestro/data-layer'

import { apiGet, apiPost } from '@maestro/core/api-client'

export const SHIPPING_ADDRESSES_SWR_KEY = 'shipping-addresses'

export function getShippingAddresses(): Promise<CompanyShippingAddress[]> {
  return apiGet<CompanyShippingAddress[]>('/api/company/shipping-addresses')
}

export function setShippingAddress(
  id?: string
): Promise<ShippingAddressSetResult> {
  return apiPost<ShippingAddressSetResult>('/api/company/shipping-address', {
    id,
  })
}
